'use strict';

module.exports = require('./es6/crc32').default;
